import React from 'react';
import { useQuill } from 'react-quilljs';
import 'quill/dist/quill.snow.css';

function EditTextQill({ text, textDir, setText, textHolder }) {
  const placeholder = textHolder;
  const theme = 'snow';
  const modules = {
    toolbar: [
      ['bold', 'italic', 'underline', 'strike'],
      [{ align: [] }],
      [{ list: 'ordered' }, { list: 'bullet' }],
      [{ indent: '-1' }, { indent: '+1' }],
    ],
  };

  const { quill, quillRef } = useQuill({ placeholder, theme, modules });

  React.useEffect(() => {
    if (quill) {
      // تعيين النص الحالي في quill عند التحميل أو تغيير القيمة
      quill.clipboard.dangerouslyPasteHTML(text || '');

      // تحديث النص عند تغيير محتوى quill
      quill.on('text-change', (delta, oldDelta, source) => {
        const newText = quillRef.current.firstChild.innerHTML;
        setText(newText);
      });
    }
  }, [quill]); // يعتمد على quill فقط

  React.useEffect(() => {
    if (quill) {
      // تحديث quill عند تغيير النص من الخارج (مثل التعديل)
      quill.clipboard.dangerouslyPasteHTML(text || '');
    }
  }, [text]); // يعتمد على text

  return (
    <div style={{ width: "100%", marginBlock: 15, height: 300 }}>
      <div ref={quillRef} />
    </div>
  );
}

export default EditTextQill;